import type { MODULES } from '@/constants';
import { createListStoreWithQuery } from '@/store/list-state.factory';

export type AuditLogStatusValue = 'All' | (typeof MODULES)[number]['value'];

export type Filters = {
  module: AuditLogStatusValue;
};
export const useAuditLogsListStore = createListStoreWithQuery('audit-logs-list-state', {
  filterDefaults: {
    module: 'All' as AuditLogStatusValue,
  },
});
